import { useFormContext } from '@calendly/form'

import { filterOutByPoolUid, findUserPool, removeUserPool, removeUserPoolUids } from '../helpers'
import { useSetValuesAndSubmit } from './use_set_values_and_submit'
import { useUserPoolsData } from './use_user_pools_data'

export const useRemoveUserPool = (eventType) => {
  const isNewEventType = !eventType?.id

  const { values: { memberships } } = useFormContext()
  const setValues = useSetValuesAndSubmit({ withSubmit: !isNewEventType })

  const {
    userPools,
    collectiveUserPoolsCount,
    roundRobinUserPoolsCount,
  } = useUserPoolsData()

  return (userPoolUid) => {
    const userPool = findUserPool(userPools, userPoolUid)

    const updatedMemberships = userPool.uuid
      ? memberships.map((membership) => (
        membership.user_pool_uid === userPoolUid ? { ...membership, _destroy: true } : membership
      ))
      : filterOutByPoolUid(memberships, userPoolUid)

    // When we remove user pools for new ET, we check if we need to convert Collective Round Robin
    if (isNewEventType) {
      const shouldConvertToCollective = collectiveUserPoolsCount === 1 && roundRobinUserPoolsCount === 1
      const shouldConvertToRoundRobin = collectiveUserPoolsCount === 0 && roundRobinUserPoolsCount === 2

      if (shouldConvertToCollective || shouldConvertToRoundRobin) {
        // And only another user pool left is collective
        // Then we convert to Collective
        return setValues((values) => ({
          ...values,
          allocationPreference: 'availability',
          pooling_type: shouldConvertToCollective ? 'collective' : 'round_robin',
          userPools: [],
          memberships: removeUserPoolUids(updatedMemberships)
        }))
      }
    }

    // When more user pools left
    // Then we remove user pool and it's memberships
    const updatedUserPools = removeUserPool(userPools, userPoolUid)

    return setValues((values) => ({
      ...values,
      userPools: updatedUserPools,
      memberships: updatedMemberships
    }))
  }
}
